import type {
  AggregateServiceModel,
  BatchServiceModel,
  ConcatServiceModel,
  FilterServiceModel,
  FlattenServiceModel,
  GroupServiceModel,
  JoinServiceModel,
  SubWorkflowServiceModel,
} from '@/types';

// The model a new service of each type starts with. Sent as the `serviceType` of the add-service request.
export function defaultServiceModel(serviceType: string): any {
  switch (serviceType) {
    case 'http':
      return {
        $type: 'http',
        targetUrl: 'www.default.com',
        httpMethod: 'GET',
        httpVersion: 'Version11',
        requestHeaders: {},
        bodyMediaTypeHeader: 'application/json',
        bodyContent: { $type: 'none' },
        validatorPipeline: [],
        regardHttpErrorAsFatal: true,
        disableChunking: false,
        requestIsRepeatable: true,
        requestTimeout: '00:01:40'
      };
    case 'httpPaging':
      return {
        $type: 'httpPaging',
        targetUrl: 'www.default.com',
        httpMethod: 'GET',
        httpVersion: 'Version11',
        requestHeaders: {},
        bodyMediaTypeHeader: 'application/json',
        bodyContent: { $type: 'none' },
        validatorPipeline: [],
        regardHttpErrorAsFatal: true,
        disableChunking: false,
        requestIsRepeatable: true,
        requestTimeout: '00:01:40',
        hasNextPageExpression: '',
        nextPage: { query: {} },
        maxPages: 500
      };
    case 'webhook':
      return {
        $type: 'webhook',
        targetUrl: '',
        httpMethod: 'POST',
        httpVersion: 'Version11',
        requestHeaders: {},
        bodyMediaTypeHeader: 'application/json',
        bodyContent: { $type: 'none' },
        validatorPipeline: [],
        regardHttpErrorAsFatal: true,
        disableChunking: false,
        requestIsRepeatable: true,
        requestTimeout: '00:01:40'
      };
    case 'javaScript':
      return {
        $type: 'javaScript',
        javaScript: '// Enter your JavaScript code here'
      };
    case 'expression':
      return {
        $type: 'expression',
        expression: ''
      };
    case 'sftp':
      return {
        $type: 'sftp',
        operation: 'Upload',
        remotePath: '',
        overwrite: false
      };
    case 'split':
      return {
        $type: 'split'
        // source authored via the binary picker
      };

    // Neither limit is set, as on the engine model. Publish asks for one.
    case 'batch':
      return { $type: 'batch' } satisfies BatchServiceModel;
    // One empty level, because a Flatten always has at least one and the editor removes only the last.
    case 'flatten':
      return { $type: 'flatten', levels: [{ path: [], flattenedKey: '', fields: [] }] } satisfies FlattenServiceModel;
    case 'group':
      return { $type: 'group', key: [], head: [], fields: [] } satisfies GroupServiceModel;
    case 'join':
      return { $type: 'join', inKey: [], key: '', include: 'Matched' } satisfies JoinServiceModel;
    case 'filter':
      return { $type: 'filter', inKey: [], key: '', include: 'Matched' } satisfies FilterServiceModel;
    // One empty text part, because a Concat always has at least one.
    case 'concat':
      return { $type: 'concat', parts: [{ $type: 'expression', expression: '' }] } satisfies ConcatServiceModel;
    case 'aggregate':
      return { $type: 'aggregate', path: [], operation: 'Sum' } satisfies AggregateServiceModel;
    case 'subWorkflow':
      return { $type: 'subWorkflow', workflowId: '', inputs: {} } satisfies SubWorkflowServiceModel;
    case 'rejoin':
    case 'wait':
    case 'return':
      return { $type: serviceType };
    case 'none':
    default:
      return { $type: 'none' };
  }
}
